import { type FC, useMemo } from 'react';

import Toast, { ToastVariant } from '@/components/toast';
import { AcresFeatureFlags } from '@/constants/constants';
import { useCustomizeLandContext } from '@/features/customizeMyLand/provider';
import { useToolbarContext } from '@/features/toolbar/provider';
import { useGetFeatureFlag } from '@/hooks/useGetFeatureFlag';
import { useFileManagementContext } from '@/providers/FileManagementProvider';

export const CustomizationEmbedWarning: FC = () => {
  const { activeFile } = useFileManagementContext();
  const isThereASavedMap = !!activeFile;

  const isToolbarActive = useGetFeatureFlag(
    AcresFeatureFlags.TEMP_TOOL_TOP_BAR
  );

  const { customizations: oldCustomizations } = useCustomizeLandContext();

  const { toolbarCustomizations } = useToolbarContext();

  const { allCustomizations } = useMemo(
    () => (isToolbarActive ? toolbarCustomizations : oldCustomizations),
    [isToolbarActive, oldCustomizations, toolbarCustomizations]
  );

  if (!allCustomizations.length || isThereASavedMap) return null;

  return (
    <Toast
      className="mx-4 mt-3 items-center py-3 pl-2 pr-0"
      closeButtonClassName="p-2 ml-[-16px] h-8 w-8"
      contentClassName="m-0"
      iconClassName="mr-2"
      subtitle="Save your map to include Drawings when sharing or generating a report."
      title="Unsaved Map"
      variant={ToastVariant.WARNING_YELLOW}
    />
  );
};
